import * as angular from 'angular';
import * as moment from 'moment';
import * as _ from 'lodash';

import template from './plantFeatureSettings.tpl.html';

import NavigationModelName, { NavigationModel, Plant } from "../../models/navigation";

import PlantServiceName, { PlantService } from "../../services/plant/plant.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";

import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import AuthDataServiceName, { AuthDataService, RoleLocation } from "../../services/auth/authData.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import PlantFeatureSettingsServiceName, { PlantFeatureSettingsService } from '../../services/plant/plantFeatureSettings.service';

import { TimeZoneService } from "../../services/utility/dateutility.service";
import { apsEnums } from "../../shared/dto/aps.enums";
import { apsCommands } from "../../shared/dto/aps.commands";
import { apsViewModels } from "../../shared/dto/APS.ViewModels";

import { Calculation, MoldLoss, Config, PlantFeatureSetting, PlantFeatureSettingPayload } from './../../models/plants/plantFeatureSettings';

import { States } from "../../shared/config/constant.module";

const requires = [NavigationModelName, PlantServiceName, LoaderServiceName,
  NewGuidServiceName, NotifyServiceName, AuthDataServiceName, NavigationServiceName, PlantFeatureSettingsServiceName];

const plantFeatureSettingsConfig = function ($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.PLANT_FEATURE_SETTINGS,
    url: '/admin/plantFeatureSettings',
    controller: 'PlantFeatureSettingsController as vm',
    template: template,
    data: {
      pageTitle: 'Plant Feature Settings',
      authorizeAdmin: true
    }
  });
}

// todo: make sure this data is retrieved from api, unfortunately, there is no data there
const jsonData: PlantFeatureSetting = {
  "id": "3999f366-42bf-41a7-a054-8815dc5e4537",
  "plantId": "bbdf0000-3a00-000f-724d-08d2e5fa8e34",
  "config": {
    "moldLoss": {
      "shops": [
        "bbdf0000-3a00-000f-72d2-08d2e5fa8e34",
        "bbdf0000-3a00-000f-60f2-08d2e5fa8e3a"
      ],
      "roles": [
        "bbdf0000-3a00-000d-76be-08d2e5f92bdb",
        "7a000000-9a3c-0005-4910-08d5f172afc7"
      ]
    },
    "defectMappingEquipmentList": [
      8,
      10,
      11,
      12,
      13,
      14
    ],
    "calculations": [
      {
        "order": 0,
        "name": "HE",
        "displayName": "HE",
        "numerator": 3,
        "denominator": 3
      },
      {
        "order": 1,
        "name": "LEHR",
        "displayName": "LEHR",
        "numerator": 3,
        "denominator": 3
      },
      {
        "order": 3,
        "name": "AIE",
        "displayName": "AIE",
        "numerator": 3,
        "denominator": 3
      },
      {
        "order": 4,
        "name": "CE LOSS",
        "displayName": "CE LOSS",
        "numerator": 3,
        "denominator": 3
      },
      {
        "order": 5,
        "name": "PACK",
        "displayName": "PACK",
        "numerator": 3,
        "denominator": 3
      },
    ]
  }
};

export class PlantFeatureSettingsController {

  navigation: NavigationModel;
  $state: angular.ui.IStateService;
  userId: string;
  isNew: boolean = true;
  plantFeatureSettingsService: PlantFeatureSettingsService;
  error: string = null;

  data: PlantFeatureSetting = jsonData;

  defectMappingEquipmentListInput: number;
  shopIdInput: string;
  roleIdInput: string;

  calculationInput: Calculation;

  plants: Plant[];
  selectedPlant: Plant;

  constructor($state: angular.ui.IStateService, authDataService: AuthDataService, navigationService: NavigationService, plantFeatureSettingsService: PlantFeatureSettingsService) {
    this.$state = $state;
    this.userId = authDataService.getUserId();
    this.calculationInput = new Calculation();
    this.plantFeatureSettingsService = plantFeatureSettingsService;

    navigationService.getNavigation().then((nav: NavigationModel) => {
      this.plants = nav.plants();
      this.selectedPlant = nav.selectedPlant;
      this.data.plantId = nav.selectedPlant.id;
      this.getPromise();
    });
  }

  selectPlant(plant: Plant) {
    if (this.navigation.selectPlant(plant)) {
      this.switchPlantShop();
    }
  }

  switchPlantShop(plantChanged?: boolean) {
    this.$state.go(this.$state.current.name, {
      plantId: this.navigation.selectedPlant.id,
      shopId: this.navigation.selectedShop.id,
      userId: this.userId
    });
  }

  plantChanged($event) {
    this.error = null;
    this.getPromise().then(() => {
    });
    return false;
  }

  deleteShopId($event, shopId: string) {
    this.data.config.moldLoss.shops = this.data.config.moldLoss.shops.filter((value) => value !== shopId);
    return false;
  }

  addShopId($event) {
    if (this.shopIdInput != null && this.data.config.moldLoss.shops.indexOf(this.shopIdInput) === -1) {
      this.data.config.moldLoss.shops.push(this.shopIdInput);
      this.shopIdInput = null;
    }
  }

  deleteRoleId($event, roleId: string) {
    this.data.config.moldLoss.roles = this.data.config.moldLoss.roles.filter((value) => value !== roleId);
    return false;
  }

  addRoleId($event) {
    if (this.roleIdInput != null && this.data.config.moldLoss.roles.indexOf(this.roleIdInput) === -1) {
      this.data.config.moldLoss.roles.push(this.roleIdInput);
      this.roleIdInput = null;
    }
  }

  deleteDefectMappingEquipment($event, defectMappingEquipment) {
    this.data.config.defectMappingEquipmentList =
      this.data.config.defectMappingEquipmentList.filter((value) => value !== defectMappingEquipment);
  }

  addDefectMappingEquipment() {
    if (this.defectMappingEquipmentListInput != null &&
      this.data.config.defectMappingEquipmentList.indexOf(this.defectMappingEquipmentListInput) === -1) {
      var defectMappingEquipment = Number(this.defectMappingEquipmentListInput);
      this.data.config.defectMappingEquipmentList.push(defectMappingEquipment);
      this.defectMappingEquipmentListInput = null;
    }
    return false;
  }

  deleteCalculation($event, calculation) {
    this.data.config.calculations =
      this.data.config.calculations.filter((value) => value !== calculation && value.name !== calculation.name);
  }

  addCalculation() {
    var calculation = new Calculation();
    calculation.order = Number(this.calculationInput.order);
    calculation.name = this.calculationInput.name;
    calculation.displayName = this.calculationInput.displayName;
    calculation.numerator = Number(this.calculationInput.numerator);
    calculation.denominator = Number(this.calculationInput.denominator);
    this.data.config.calculations.push(calculation);

    this.calculationInput = new Calculation();
  }

  moveItem(data, from, to) {
    var f = data.splice(from, 1)[0];
    data.splice(to, 0, f);
  }

  getPayload() {
    var payload = {
      id: this.data.plantId,
      plantId: this.data.plantId,
      config: JSON.stringify(this.data.config)
    } as PlantFeatureSettingPayload;
    return payload;
  }

  parse(payload: PlantFeatureSettingPayload): PlantFeatureSetting {
    let result = new PlantFeatureSetting();
    this.isNew = !payload;
    if (payload === null || !payload) {
      result.id = this.data.plantId;
      result.plantId = this.data.plantId;
      result.config = new Config();
    } else {
      result.id = payload.id;
      result.plantId = payload.plantId;
      result.config = JSON.parse(payload.config) as Config;

      //Added the check below as the JSON coming from API may not have moldLoss node in JSON file. 
      //Hence the object will be missing post parsing. This fix ensures that there is a default moldLoss, so that add function does not error out.
      if(result.config.moldLoss === undefined){
        result.config.moldLoss = new MoldLoss();
      }
    }
    return result;
  }

  getPromise() {
    console.log("getPromise - started...");
    return this.plantFeatureSettingsService.get(this.data.plantId)
      .then((data: PlantFeatureSettingPayload) => {
        console.log("getPromise - completed.");
        this.data = this.parse(data);
      })
      .catch((err) => this.handleError(err));
  }

  savePromise() {
    var payload = this.getPayload();
    var promise = (this.isNew
      ? this.plantFeatureSettingsService.post(payload).then(() => console.log("post"))
      : this.plantFeatureSettingsService.put(payload).then(() => console.log("put"))
    ).then(() => this.getPromise())
      .catch((err) => this.handleError(err));

    return promise;
  }

  handleError(err) {
    this.error = err;
    alert(err);
  }

  submit() {
    this.error = null;
    this.savePromise();
  }
}

export default angular.module('aps.controller.plantFeatureSettings', requires)
  .config(plantFeatureSettingsConfig)
  .controller('PlantFeatureSettingsController', PlantFeatureSettingsController)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/plants/plantFeatureSettings.controller.ts